import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { isEmpty, groupBy } from "lodash";
import { Form } from "react-bootstrap";
import "../../styles/components/PlanlevelCommunication.scss";
import { faEnvelope, faSms } from "@fortawesome/free-solid-svg-icons";
import { faTimes } from "@fortawesome/pro-light-svg-icons";
import AddToolTip from "../AddToolTip";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  SliderPanel,
  ManageCommunicationLayout,
  LoaderWrapper,
} from "../../components";
import {
  savePlanCommunication,
  getCommunicationDetailsById,
} from "../../services";
import {
  FLOW_TYPES,
  getAdvancedPathWithParam,
  getPathWithParam,
  MANAGE_COMMUNICATION_ROUTES,
} from "../../utils";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import { useRef } from "react";
import { useContext } from "react";
import {
  manageCommunicationStore,
  setManageCommunicationFullPageData,
} from "../../contexts";
const PlanlevelCommunication = (props) => {
  const {
    labels,
    data,
    setActiveMail,
    setActiveSMS,
    setFilterData,
    eventId,
    planId,
    CommunicationMode,
    setStatusChangeToggle,
    statusChangeToggle,
    apiResponse,
    setData1,
    communicationMode,
    history,
  } = props;
  const { state, dispatch } = useContext(manageCommunicationStore);
  const [showEditor, setShowEditor] = useState(false);
  const [showDropDown, setShowDropDown] = useState(false);
  const [loading, setLoading] = useState(false);
  const CommunicationInfo = useRef({});
  const icons = ["", faEnvelope, faSms];
  const labelIndex = data.modeOfCommunication == 1 ? 0 : 1;
  const planLevelLabels = [
    [
      // { label: "Welcome Mail", columnName: "communicationDetail" },
      { label: "Plan Group", columnName: "planGroupOrPlanName" },
      { label: "Recipients", columnName: "recipients" },
      { label: "Layout", columnName: "layoutName" },
    ],
    [
      { label: "Welcome SMS", columnName: "communicationDetail" },
      // { label: "Plan Group", columnName: "planGroupOrPlanName" },
      { label: "Character Limit", columnName: "characterlimit" },
    ],
  ];

  const buttons = [
    {
      label: "",
      variant: "link",
      type: "button",
      //flow: [FLOW_TYPES.EDIT],
      icon: faTimes,
      onClick: () => setShowEditor(false),
    },
  ];

  useEffect(() => {
    getCommunicationDetailsById(data.id).then((response) => {
      setLoading(false);
      CommunicationInfo.current.value = response;
    }, []);
  });
  const changeData = (elementData) => {
    savePlanCommunication({
      AcceptedCommunicationMode: elementData?.modeOfCommunication,
      eventId: eventId,
      planId: planId,
      communicationId: elementData.id,
    })
      .then((response) => {
        if (response.isSuccessfull) {
          var result = response.configuredCommunicationsOfEvent;
          apiResponse.current = result;
          let x = groupBy(result, "level");
          setData1(x);
          setFilterData(x);
          const res = result.filter((x) => x.isActive);
          setStatusChangeToggle(!statusChangeToggle);
          const mail = res.find((x) => x.modeOfCommunication === 1);
          const sms = res.find((x) => x.modeOfCommunication === 2);
          if (!isEmpty(mail))
            setActiveMail(
              `${mail?.communicationDetail.name}/${
                communicationMode[mail?.level]
              }`
            );
          else setActiveMail("");
          if (!isEmpty(sms))
            setActiveSMS(
              `${sms?.communicationDetail.name}/${
                communicationMode[sms?.level]
              }`
            );
          else setActiveSMS("");
        }
      })
      .catch(() => {});
  };

  return (
    <>
      <div className="planlevel-card">
        <div className="planlevel-labels mb-5">
          {planLevelLabels[labelIndex].map((item, index) => {
            if (item.columnName === "communicationDetail")
              return (
                <div className={`component ${item.columnName}`}>
                  <div
                    className="label ft-14 ftwt-500"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      flexWrap: "wrap",
                    }}
                  >
                    <FontAwesomeIcon
                      icon={icons[data.modeOfCommunication]}
                      size="lg"
                      style={{ paddingRight: "5px" }}
                    />
                    {<AddToolTip name={data[item.columnName].name} />}
                  </div>
                  <div className="item ft-12">
                    {<AddToolTip name={data[item.columnName].description} />}
                  </div>
                </div>
              );
            else if (item.columnName === "planGroupOrPlanName") {
              item.label = data.communicationDetail.name;
            }
            return (
              <div className={`component ${item.columnName}`}>
                <p className="label">
                  {item.columnName === "planGroupOrPlanName" ? (
                    <>
                      <FontAwesomeIcon
                        icon={icons[data.modeOfCommunication]}
                        size="lg"
                        style={{ paddingRight: "5px" }}
                      />
                      {item.label}
                    </>
                  ) : (
                    <p className="label">{item.label}</p>
                  )}
                </p>
                <div className="item ftwt-500">
                  {data[item.columnName]?.length < 20 ? (
                    <p
                      className="item"
                      style={{
                        whiteSpace: "nowrap",
                      }}
                    >
                      {data[item.columnName] || ""}
                    </p>
                  ) : (
                    <OverlayTrigger
                      placement="top-start"
                      overlay={<Tooltip>{data[item.columnName]}</Tooltip>}
                    >
                      <p
                        className="item"
                        style={{
                          textOverflow: "ellipsis",
                          maxWidth: "100%",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                          height: "20px",
                        }}
                      >
                        {data[item.columnName]}
                      </p>
                    </OverlayTrigger>
                  )}
                </div>
              </div>
            );
          })}
          <div style={{ width: "8%" }}>
            <div className="ft-14 grey mb-8 planlvlstatus">Status</div>
            <Form.Check
              type="switch"
              //autoFocus="off"
              id={data.id}
              checked={data.isActive}
              onChange={() => changeData(data)}
            />
          </div>
          <div
            style={{
              width: "30px",
              display: "flex",
              alignItems: "start",
              marginTop: "36px",
            }}
            onClick={() => setShowDropDown(!showDropDown)}
          >
            <i
              class="fas fa-ellipsis-v"
              style={{ color: "black" }}
              aria-hidden="true"
            ></i>
            {showDropDown ? (
              <div className="ellipsis-dropdown">
                <div className="mb-2">
                  <Link
                    to={getPathWithParam({
                      path: `${MANAGE_COMMUNICATION_ROUTES.COMMUNICATION_INFO}`,
                      pathParam: [FLOW_TYPES.EDIT, data.id],
                    })}
                    style={{ textDecoration: "none" }}
                  >
                    <i className="fas fa-eye"></i> View More Detail
                  </Link>
                </div>
                <div>
                  <Link
                    onClick={() => {
                      dispatch(
                        setManageCommunicationFullPageData({
                          communication: CommunicationInfo.current.value,
                          entryFromNewCommunication: false,
                          isDuplicate: true,
                        })
                      );
                      history.push(
                        getAdvancedPathWithParam({
                          path: `${MANAGE_COMMUNICATION_ROUTES.COMMUNICATION_INFO}`,
                          queryParam: [`/${FLOW_TYPES.ADD}`],
                          //pathParam: [flow, censusId],
                        })
                      );
                    }}
                    // to={getAdvancedPathWithParam({
                    //   path: `${MANAGE_COMMUNICATION_ROUTES.COMMUNICATION_INFO}`,
                    //   pathParam: [FLOW_TYPES.SAVE, data.id],
                    // })}
                    style={{ textDecoration: "none" }}
                  >
                    <i class="fa fa-clone"></i> Create Duplicate
                  </Link>
                </div>
              </div>
            ) : (
              <div
                style={{
                  width: "187px",
                  marginLeft: "-130px",
                }}
              ></div>
            )}
          </div>
        </div>
      </div>
      <SliderPanel isOpen={showEditor} size="38" showCancel={false}>
        <div className="d-flex mr-600">
          <ManageCommunicationLayout
            pageName={data.layoutName}
            buttons={buttons}
          >
            <div className="Container">
              <img src={data.imagePath} width="523px" height="640px" />
            </div>
          </ManageCommunicationLayout>
        </div>
      </SliderPanel>
    </>
  );
};

export default PlanlevelCommunication;
